import api from "@/services/api";

const state = {
  tickets: [],
  ticket: null,
};

const mutations = {
  SET_Tickets(state, tickets) {
    state.tickets = tickets;
  },
  SET_Ticket(state, ticket) {
    state.ticket = ticket;
  },
};

const actions = {
  async getTickets({ commit }) {
    try {
      const res = await api.get("/tickets");
      commit("SET_Tickets", res.data);
    } catch (error) {
      console.error("Error fetching tickets:", error.message);
      throw error;
    }
  },

  async getTicket({ commit }, id) {
    try {
      const res = await api.get(`/tickets/${id}`);
      commit("SET_Ticket", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching ticket:", error.message);
      throw error;
    }
  },

  async createTicket(_, payload) {
    try {
      return await api.post("/tickets", payload);
    } catch (error) {
      console.error("Error creating ticket:", error.message);
      throw error;
    }
  },

  async updateTicket(_, { id, payload }) {
    try {
      await api.put(`/tickets/${id}`, payload);
    } catch (error) {
      console.error("Error updating ticket:", error.message);
      throw error;
    }
  },

  async deleteTicket(_, id) {
    try {
      await api.delete(`/tickets/${id}`);
    } catch (error) {
      console.error("Error deleting ticket:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};